import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import canUseDom from "rc-util/es/Dom/canUseDom";
import defaultLocale from '../ConfigProvider/locales/zh-CN/Modal';

var runtimeLocale = _objectSpread({}, defaultLocale);

export function getRuntimeLocale() {
  return runtimeLocale;
}
export function setRuntimeLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = _objectSpread(_objectSpread({}, runtimeLocale), newLocale);
  } else {
    runtimeLocale = _objectSpread({}, defaultLocale);
  }
}
export var canUseDocElement = function canUseDocElement() {
  return canUseDom() && window.document.documentElement;
};
export var destroyFns = [];